// extracted by mini-css-extract-plugin
export var inputContainer = "_s3-0";